<template>
<section>
  <!-- class="display-1" -->
  <h1 style="
      border-width: 0px 0px 1px 0px;
      border-style: solid;
      border-color: #cccccc;
      ">
    Email検証
  </h1>
  <div>
    <template v-if="counter == 0">
      <p>ご利用には<template v-if="user">{{ user.email }}</template><template v-else>Email</template>の有効性を検証する必要があります。</p>
      <p>確認用のメールを送信しますか？</p>
    </template>
    <template v-else>
      <p><template v-if="user">{{ user.email }}に</template><template v-else>Emailで</template>送信された確認用URLにアクセスしてください。</p>
    </template>
    <button class="btn btn-primary" @click="handleVerification">確認メール送信</button>
    <button class="btn btn-danger" @click="handleLogout">ログアウト</button>
  </div>
</section>
</template>

<style>
.waiting {
  display: none;
}
</style>

<script>
import firebase from "firebase"
import store from '../store'

export default {
  name: 'emailverification',
  data() {
    return {
      counter: 0,
      // 注意： リロード直後はcurrentUserはnull
      user: firebase.auth().currentUser
    };
  },
  methods: {
    handleVerification() {
      firebase.auth().currentUser.sendEmailVerification()
      this.counter += 1
    },
    handleLogout() {
      firebase.auth().signOut().then(() => {
        this.$router.push({name: 'index'})
        store.state.loginUser.session.user = null
      })
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/EmailVerification.vue